import { useMemo } from 'react';
import { useAdditionalGeneralStockLevels, useSelectedProducts } from '../useCustomerCatalogueService';
import { StockBinLevel } from './useDefaultBundleStockLevels';

export const useGeneralStockLevels = () => {
  const additionalStockLevels = useAdditionalGeneralStockLevels();
  const bundledProducts = useSelectedProducts();

  return useMemo(() => {
    const stockLevels: StockBinLevel[] = bundledProducts.map(product => {
      const additionalStock = additionalStockLevels.find(a => a.productId === product.id);

      return {
        product,
        maxStockLevel: additionalStock?.maximumStockLevel ?? 0,
        minStockLevel: additionalStock?.minimumStockLevel ?? 0
      };
    });

    return stockLevels;
  }, [bundledProducts]);
};
